import { FeatureGate } from '@orn/global/featureGates/featureGates.js';

import OnboardingFlow from '../components/OnboardingFlow';
import OnboardingWizard from '../components/OnboardingWizard';
import { useFeatureGates } from '../hooks/useFeatureGates';

/**
 * Route entry for `/onboarding`. Branches on `feat-onboarding-v2`:
 * - On → renders the new {@link OnboardingFlow}, which owns its own route
 *   decision (resume the flow, or redirect a fully-onboarded viewer to the
 *   dashboard) and full-screen layout.
 * - Off → renders the legacy {@link OnboardingWizard} inside the existing brand wrapper.
 *
 * Renders `null` while the gate set is bootstrapping (fail-closed) so the
 * legacy wizard can't flash before the v2 gate resolves for an enabled
 * viewer. Same pattern as `ObligationsRouteGate` / `AssistantRouteGate` in
 * `MainApp.tsx`. The legacy wizard comes out entirely once v2 graduates to
 * `ALL_USERS` and the gate is retired (see ORN-582).
 *
 * `OnboardingFlow` only mounts on the v2 branch, so legacy gate-off viewers
 * never fire its `useOnboardingState` query.
 */
const OnboardingScene = () => {
  const { flags, loading } = useFeatureGates();
  if (loading && flags.size === 0) {
    return null;
  }
  if (flags.has(FeatureGate.OnboardingV2)) {
    return <OnboardingFlow />;
  }
  return (
    <div className="bg-brand-solid flex h-full w-full flex-col items-center justify-center">
      <OnboardingWizard />
    </div>
  );
};

export default OnboardingScene;
